import dayjs from 'dayjs'

// 深層拷貝
export function deepCopy(data) {
  let info = ''
  // 如果不是 null、undefined、空字串、數字0就使用 JSON方法過濾, 否則直接返回 info 預設值(空字串)
  !!data && (info = JSON.parse(JSON.stringify(data)))
  return info
}

// 數值轉換成千分符號
function replaceFractionDigits(val = null) {
  // eslint-disable-next-line prefer-regex-literals
  const regExp = new RegExp('(\\d{1,3})(?=(\\d{3})+(?:$|\\D))', 'g')
  return typeof val === 'number' ? val.toString().replace(regExp, '$1,') : val
}

// 數值亂數轉換
export function getRandomIntInclusive(min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1) + min)
}

// 亂數取得資料
export function getRandomData(arr = []) {
  const index = getRandomIntInclusive(0, arr.length - 1)
  return arr[index]
}

// 時間格式化
function dateFormated(date = '', formated = 'YYYY-MM-DD') {
  if (!date) return
  return dayjs(date).format(formated)
}

// 當地時間轉成+0時區時間
export function dateUtcToZeroZone(date = null, formated = '', zone = 8) {
  if (!date) return
  const dateTimestamp = dayjs(date).valueOf()
  const zoneTimestamp = zone * 60 * 60 * 1000
  const finalTimestamp = dateTimestamp - zoneTimestamp
  return formated ? dateFormated(finalTimestamp, formated) : finalTimestamp
}

// +0時區時間轉成當地時區時間
export function dateUtcToLocalZone(
  date = null,
  formated = 'YYYY-MM-DD',
  zone = 8
) {
  if (!date) return
  const dateTimestamp = dayjs(date).valueOf()
  const zoneTimestamp = zone * 60 * 60 * 1000
  const finalTimestamp = dateTimestamp + zoneTimestamp
  return formated ? dateFormated(finalTimestamp, formated) : finalTimestamp
}

// 不是 undefined 也不是 null
function isNotNullUndefined(value) {
  return value !== undefined && value !== null
}

// 有值回傳 value ，其餘回傳 --
export function getOrDefault(value, defaultValue = '--') {
  return isNotNullUndefined(value) && value.toString().trim() !== ''
    ? value
    : defaultValue
}

// 有值 且 >0 回傳 value ，其餘回傳 --
export function getGtZerorDefault(value, defaultValue = '--') {
  return isNotNullUndefined(value) && value > 0 ? value : defaultValue
}

// 是否為圖檔格式
export function isImgFile(extension) {
  const imgTypes = ['jpeg', 'jpg', 'png', 'webp', 'svg']
  return extension ? imgTypes.includes(extension) : false
}
